import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { fetchData } from './utils/functions';

export default function AdminPage() {
  // const roleQuery = useQuery('roleData', () => fetchData('role'));
  // const userQuery = useQuery('userData', () => fetchData('user'));
  const sourceCityQuery = useQuery('sourceCityData', () => fetchData('source-city'));
  const sourceStateQuery = useQuery('sourceStateData', () => fetchData('source-state'));
  const sourceAreaQuery = useQuery('sourceAreaData', () => fetchData('source-area'));
  const sourceTypeQuery = useQuery('sourceTypeData', () => fetchData('source-type'));
  const sourceQuery = useQuery('sourceData', () => fetchData('source'));
  const locationQuery = useQuery('locationData', () => fetchData('location'));
  const itemQuery = useQuery('itemData', () => fetchData('item'));
  const featuredImageQuery = useQuery('featuredImageData', () => fetchData('featured-image'));
  const extraImageQuery = useQuery('extraImageData', () => fetchData('extra-image'));
  const tagQuery = useQuery('tagData', () => fetchData('tag'));
  const tagTypeQuery = useQuery('tagTypeData', () => fetchData('tag-type'));
  const tagTagTypeQuery = useQuery('tagTagTypeData', () => fetchData('tag-tag-type'));
  const itemTagQuery = useQuery('itemTagData', () => fetchData('item-tag'));
  const statusQuery = useQuery('statusData', () => fetchData('status'));
  const salesChannelQuery = useQuery('salesChannelData', () => fetchData('sales-channel'));
  const itemStatusQuery = useQuery('itemStatusData', () => fetchData('item-status'));
  const treasureQuery = useQuery('treasureData', () => fetchData('treasure'));
  const [treasure, setTreasure] = useState(null);

  useEffect(() => {
    if (treasureQuery.data) {
      console.log('treasureQuery', treasureQuery.data)
    }
  }, [treasureQuery.data]);

  useEffect(() => {
    if (
      // roleQuery.data &&
      // userQuery.data &&
      sourceCityQuery.data &&
      sourceStateQuery.data &&
      sourceAreaQuery.data &&
      sourceTypeQuery.data &&
      sourceQuery.data &&
      locationQuery.data &&
      itemQuery.data &&
      featuredImageQuery.data &&
      extraImageQuery.data &&
      tagQuery.data &&
      tagTypeQuery.data &&
      tagTagTypeQuery.data &&
      itemTagQuery.data &&
      statusQuery.data &&
      salesChannelQuery.data &&
      itemStatusQuery.data
    ) {
      // console.log('roleQuery', roleQuery.data)
      // console.log('userQuery', userQuery.data)
      console.log('sourceCityQuery', sourceCityQuery.data)
      console.log('sourceStateQuery', sourceStateQuery.data)
      console.log('sourceAreaQuery', sourceAreaQuery.data)
      console.log('sourceTypeQuery', sourceTypeQuery.data)
      console.log('sourceQuery', sourceQuery.data)
      console.log('locationQuery', locationQuery.data)
      console.log('itemQuery', itemQuery.data)
      console.log('featuredImageQuery', featuredImageQuery.data)
      console.log('extraImageQuery', extraImageQuery.data)
      console.log('tagQuery', tagQuery.data)
      console.log('tagTypeQuery', tagTypeQuery.data)
      console.log('tagTagTypeQuery', tagTagTypeQuery.data)
      console.log('itemTagQuery', itemTagQuery.data)
      console.log('statusQuery', statusQuery.data)
      console.log('salesChannelQuery', salesChannelQuery.data)
      console.log('itemStatusQuery', itemStatusQuery.data)
    }
  }, [
    // roleQuery.data,
    // userQuery.data,
    sourceCityQuery.data,
    sourceStateQuery.data,
    sourceAreaQuery.data,
    sourceTypeQuery.data,
    sourceQuery.data,
    locationQuery.data,
    itemQuery.data,
    featuredImageQuery.data,
    extraImageQuery.data,
    tagQuery.data,
    tagTypeQuery.data,
    tagTagTypeQuery.data,
    itemTagQuery.data,
    statusQuery.data,
    salesChannelQuery.data,
    itemStatusQuery.data
  ]);

  return (
    <div>
      soon...
    </div>
  );
}
